import { ReactSVG } from "react-svg";
import { classNames } from "helpers";
import { BadgeProps } from "./types";

const Badge: React.FC<BadgeProps> = (props) => {
    const { text, variant, height = "normal", showDot, icon } = props;

    const variantClassName = () => {
        switch (variant) {
            case "info":
                return "bg-blue-100 text-blue-800";
            case "warning":
                return "bg-yellow-100 text-yellow-800";
            case "danger":
                return "bg-red-100 text-red-800";
            case "success":
                return "bg-green-100 text-green-800";
            case "success-dark":
                return "bg-green-700 text-white";
            case "secondary":
                return "bg-slate-100 text-slate-700";
            case "violet":
                return "bg-violet-100 text-violet-800";
            default:
                return "";
        }
    };

    const dotClassName = () => {
        switch (variant) {
            case "info":
                return "bg-blue-500";
            case "warning":
                return "bg-yellow-500";
            case "danger":
                return "bg-red-500";
            case "success":
                return "bg-green-500";
            case "success-dark":
                return "bg-white";
            case "secondary":
                return "bg-slate-400";
            case "violet":
                return "bg-violet-500";
            default:
                return "";
        }
    };

    const heightClassName = () => {
        switch (height) {
            case "small":
                return "px-2.5 py-1 text-xs";
            case "normal":
            default:
                return "px-3.5 py-1 text-sm";
        }
    };

    return (
        <div className="">
            <div className={classNames("inline-flex items-center gap-1.5 mr-1 font-medium rounded-full", heightClassName(), variantClassName())}>
                {icon ? (
                    <ReactSVG src={icon} className="w-3.5 h-3.5 [&_svg]:stroke-current" />
                ) : showDot && (
                    <span className={classNames("w-2 h-2 rounded-full", dotClassName())} />
                )}
                {text}
            </div>
        </div>
    );
};

export default Badge;
